import { Controller } from '@hotwired/stimulus';
import _ from 'lodash';

export default class ProgramsFilterPillsController extends Controller {
  static targets = ['pillsSection', 'filter'];

  connect () {
    this.updateAllPills();
  }

  initialize () {
    this.updateInputFilterPill = _.debounce(this.updateInputFilterPill, 500);
  }

  updateAllPills () {
    this.pillsSectionTarget.innerHTML = '';

    this.filterTargets.forEach((filter) => {
      if (filter.type === 'checkbox') {
        const pillText = filter.nextElementSibling.innerHTML;
        if (pillText && filter.checked) this.createPill(pillText, filter);
      } else if (filter.type === 'text') {
        const text = filter.value;
        if (text) this.createPill(text, filter);
      }
    });
  }

  updateFilterPill (event) {
    const filter = event.target;
    if (filter.checked) {
      const pillText = filter.nextElementSibling.innerHTML;

      if (pillText) this.createPill(pillText, filter);
    } else {
      this.deletePill(filter);
    }
  }

  updateInputFilterPill (event) {
    const text = event.target.value;
    this.deletePill(event.target);
    if (text !== '') {
      this.createPill(text, event.target);
    }
  }

  clearAllPills () {
    this.pillsSectionTarget.innerHTML = '';
  }

  clearFiltersPills (event) {
    const filterId = event.target.dataset.filter;

    this.filterTargets.filter(filter => filter.name === filterId).forEach((filter) => {
      this.deletePill(filter);
    });
  }

  createPill (text, targetElement) {
    const span = document.createElement('span');
    span.innerHTML = text;
    span.classList.add('filters__pill');

    const button = document.createElement('button');
    button.innerHTML = '&times;';
    button.classList.add('filters__clear');
    button.setAttribute('data-filter-id', targetElement.id);
    if (targetElement.type === 'checkbox') {
      button.setAttribute('data-action', 'enterprise-admin--programs-filter#pillSelectChange');
    } else if (targetElement.type === 'text') {
      button.setAttribute('data-action', 'enterprise-admin--programs-filter#pillInputChange');
    }

    span.appendChild(button);
    this.pillsSectionTarget.appendChild(span);
  }

  deletePill (targetElement) {
    const pill = Array.from(this.pillsSectionTarget.children)
      .find(item => item.lastChild.dataset.filterId === targetElement.id);

    if (pill) pill.remove();
  }
}
